"use client"

import useIsMobile from "@/lib/config/lib/use-is-mobile"
import { ComponentConfig } from "@measured/puck"

import { CommonStylesProps } from "../../../lib/commonCSSProps"
import { generateResponsiveCSS } from "../../../lib/helper"

export interface TableColumn {
  label: string
  align?: "left" | "center" | "right"
  fontWeight?: string
}

export interface TableRow {
  cells: { value: string }[]
}

export interface BikeRentalTableProp extends CommonStylesProps {
  columns?: TableColumn[]
  rows?: TableRow[]
}

export const RenderConfig: ComponentConfig<BikeRentalTableProp> = {
  render: ({ columns = [], rows = [], styles, responsiveType }: BikeRentalTableProp) => {
    const id = `caocao-bike-rental-table-${Math.random().toString(36).substr(2, 9)}`
    const responsiveCSS = generateResponsiveCSS(id, styles || {}, responsiveType)
    const isMobile = useIsMobile()

    return (
      <>
        {responsiveCSS}
        <div id={id}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
              {columns.length > 0 && (
                <thead>
                  <tr>
                    {columns.map((col, idx) => (
                      <th
                        key={`th-${idx}`}
                        style={{
                          fontSize: "14px",
                          lineHeight: "22px",
                          textAlign: col.align || "left",
                          padding: "20px 0px",
                          background: "#0C9443",
                          color: "#fff",
                          borderBottom: "1px solid #6670851F",
                          whiteSpace: isMobile ? "nowrap" : undefined,
                          width: `${100 / columns.length}%`,
                          fontWeight: "600",
                        }}
                      >
                        {col.label}
                      </th>
                    ))}
                  </tr>
                </thead>
              )}
              <tbody>
                {rows.map((row, rIdx) => (
                  <tr key={`tr-${rIdx}`}>
                    {(row.cells || []).map((cell, cIdx) => (
                      <td
                        key={`td-${rIdx}-${cIdx}`}
                        style={{
                          textAlign: columns[cIdx]?.align || "left",
                          padding: "12px 0px",
                          borderBottom: "1px solid #e5e7eb",
                          whiteSpace: isMobile ? "nowrap" : undefined,
                          width: `${100 / columns.length}%`,
                          fontWeight: columns[cIdx]?.fontWeight || "400",
                        }}
                        className="text-base leading-[22px]"
                      >
                        {cell.value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </>
    )
  },
}
